var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tender-container-wrapper" }, [
    _c(
      "div",
      { staticClass: "tender-container" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isWappr && _vm.isPicView,
                expression: "isWappr && isPicView",
              },
            ],
            staticClass: "callout success",
          },
          [
            _c("span", { staticClass: "tender-font" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("hint.waitApproval", [
                    _vm.userHelper.getUserName(
                      (_vm.general.manager || {}).username,
                      (_vm.general.manager || {}).displayName
                    ),
                    _vm.userHelper.getUserName(
                      (_vm.general.approver || {}).username,
                      (_vm.general.approver || {}).displayName
                    ),
                  ])
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isAppr && _vm.isPicView,
                expression: "isAppr && isPicView",
              },
            ],
            staticClass: "callout success",
          },
          [
            _c("span", { staticClass: "tender-font" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("hint.waitIssued", [
                    _vm.userHelper.getUserName(
                      (_vm.general.manager || {}).username,
                      (_vm.general.manager || {}).displayName
                    ),
                  ])
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "tender-head",
          {
            ref: "tenderEditHead",
            attrs: { tenderGeneral: _vm.tender.general },
          },
          [
            !_vm.isCancelled
              ? _c(
                  "div",
                  [
                    (_vm.isDraft || _vm.isRejected) &&
                    (_vm.isPicView || _vm.isRepresentative)
                      ? _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "note",
                                rawName: "v-note",
                                value: {
                                  text: _vm.noteText,
                                  enable: !_vm.editable,
                                },
                                expression: "{text:noteText, enable:!editable}",
                              },
                            ],
                            staticClass: "btn btn--darkblue",
                            attrs: {
                              disabled: !_vm.editable || _vm.isTenderRepEditing,
                              type: "button",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.goEdit()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("action.edit")) + "\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isPicView
                      ? [
                          (
                            _vm.isTender
                              ? _vm.enableEditClosingDate &&
                                (_vm.isAppr || _vm.isWappr)
                              : _vm.enableEditClosingDate
                          )
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn--orange",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.save()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("action.save")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("SubmitTender", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.isTenderPreview &&
                                  !_vm.readonly &&
                                  _vm.isFromSubmit,
                                expression:
                                  "isTenderPreview && !readonly && isFromSubmit",
                              },
                            ],
                            attrs: { disabled: !_vm.editable },
                          }),
                          _vm._v(" "),
                          !(_vm.isTenderPreview || _vm.readonly) &&
                          _vm.isFromSubmit
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn--orange",
                                  attrs: {
                                    type: "button",
                                    disabled: !_vm.editable,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.issue()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("action.issue")))]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTmView && _vm.isWappr
                      ? [
                          _c("reject-tender", {
                            attrs: { tenderInfo: _vm.general },
                            on: {
                              "update:tenderInfo": function ($event) {
                                _vm.general = $event
                              },
                              "update:tender-info": function ($event) {
                                _vm.general = $event
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn--orange",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.approve()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("action.approve")))]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.tender.general.version
          ? _c(
              "RecentAddendum",
              { attrs: { isBid: false } },
              [
                _c(
                  "template",
                  { slot: "vendor-bid-status" },
                  [
                    _vm.showVendorStatusList
                      ? _c("VendorBidStatusCollapse")
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isTenderPreview
          ? _c(
              "div",
              [
                _c("closing-date", {
                  ref: "closingDate",
                  attrs: { partialClosingDate: _vm.partialClosingDate },
                  on: {
                    "update:partialClosingDate": function (val) {
                      return (_vm.partialClosingDate = val)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "tender-tabs-container",
          { attrs: { isTender: _vm.isTender } },
          [
            !_vm.isCancelled
              ? _c(
                  "div",
                  [
                    (_vm.isDraft || _vm.isRejected) &&
                    (_vm.isPicView || _vm.isRepresentative)
                      ? _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "note",
                                rawName: "v-note",
                                value: {
                                  text: _vm.noteText,
                                  enable: !_vm.editable,
                                },
                                expression: "{text:noteText, enable:!editable}",
                              },
                            ],
                            staticClass: "btn btn--darkblue mini-btn",
                            attrs: { disabled: !_vm.editable, type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.goEdit()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("action.edit")) + "\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isPicView
                      ? [
                          (
                            _vm.isTender
                              ? _vm.enableEditClosingDate &&
                                (_vm.isAppr || _vm.isWappr)
                              : _vm.enableEditClosingDate
                          )
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn--orange mini-btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.save()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("action.save")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("SubmitTender", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.isTenderPreview &&
                                  !_vm.readonly &&
                                  _vm.isFromSubmit,
                                expression:
                                  "isTenderPreview && !readonly && isFromSubmit",
                              },
                            ],
                            attrs: {
                              id: "sticky",
                              className: "btn btn--orange mini-btn",
                              disabled: !_vm.editable,
                            },
                          }),
                          _vm._v(" "),
                          !(_vm.isTenderPreview || _vm.readonly) &&
                          _vm.isFromSubmit
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn--orange mini-btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.issue()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("action.issue")))]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTmView && _vm.isWappr
                      ? [
                          _c("reject-tender", {
                            attrs: {
                              id: "sticky",
                              tenderInfo: _vm.general,
                              className: "btn btn--darkblue mini-btn",
                            },
                            on: {
                              "update:tenderInfo": function ($event) {
                                _vm.general = $event
                              },
                              "update:tender-info": function ($event) {
                                _vm.general = $event
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn--orange mini-btn",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.approve()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("action.approve")))]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tenderId === _vm.currentTender.general.id
              ? _c("general", { attrs: { slot: "general" }, slot: "general" })
              : _vm._e(),
            _vm._v(" "),
            _c("scope-of-work", {
              attrs: { slot: "scopeOfWork" },
              slot: "scopeOfWork",
            }),
            _vm._v(" "),
            _c("items-services", {
              attrs: { slot: "itemServices" },
              slot: "itemServices",
            }),
            _vm._v(" "),
            _c("attachments", {
              attrs: {
                slot: "fileUpload",
                files: _vm.attachment.files,
                description: _vm.attachment.description,
                zipName: _vm.zipNames.attachments,
              },
              slot: "fileUpload",
            }),
            _vm._v(" "),
            _c("terms-conditions", {
              attrs: {
                slot: "termsConditions",
                tenderId: _vm.tenderId,
                isTender: _vm.isTender,
                zipName: _vm.zipNames.terms,
              },
              slot: "termsConditions",
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("TenderRepresentative", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTenderRep,
              expression: "showTenderRep",
            },
          ],
          attrs: { isEditing: _vm.isTenderRepEditing },
          on: {
            "update:isEditing": function ($event) {
              _vm.isTenderRepEditing = $event
            },
            "update:is-editing": function ($event) {
              _vm.isTenderRepEditing = $event
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }